// @flow strict

import * as React from 'react';

/** Tracking impression context props */
type TripTrackingImpressionContextProps = {|
  /** The id of the nearest impression. Will be undefined if there is no parent impression */
  impressionId?: string,
  /** Whether or not the nearest parent impression has been logged */
  isImpressionLogged?: boolean,
|};

const defaultContext: TripTrackingImpressionContextProps = Object.freeze({});

/**
 * Tracking impression context.
 */
const TripTrackingImpression: React.Context<TripTrackingImpressionContextProps> = React.createContext(
  defaultContext,
);
const { Provider } = TripTrackingImpression;

type TrackingImpressionProviderProps = {|
  ...TripTrackingImpressionContextProps,

  children: React.Node,
|};

/** Tracking impression context provider */
const TrackingImpressionContextProvider = (props: TrackingImpressionProviderProps) => {
  const { children, ...providerValue } = props;
  return <Provider value={providerValue}>{children}</Provider>;
};
TrackingImpressionContextProvider.defaultProps = {
  impressionId: undefined,
  isImpressionLogged: false,
};

export { TripTrackingImpression, TrackingImpressionContextProvider };
